import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import LocationHeader from "../components/main/LocationHeader";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import ScrollNavbar from "../components/ScrollNavbar";
import NumberIncrement from "../components/NumberIncrement";
import ExploreGroomingService from "../components/ExploreGroomingService";
import LocationComponent from "../components/main/LocationComponent";
import MeetExpertsComponent from "../components/main/MeetExpertsComponent";
import HowFt from "../components/HowFt"; 
import LocationFaqComponent from "../components/main/LocationFaqComponent";
import NavTop from "../components/NavTop";
import OurLocation from "../components/OurLocation";
import LocationContentGhaziabad from "../components/main/LocationContentGhaziabad";
import PopupOffer from "../components/PopupOffer";
import GroomingFormComponent from "../components/form/GroomingFormComponent";
import LocationGroomingPackageComponent from "../components/LocationGroomingPackageComponent";

const GhaziabadPage = () => {
  const [openForm, setOpenForm] = useState(false);


  const [offerPopup, setOfferPopup] = useState(false);

      const [petGroom, setPetGroom] = useState("Dog")
  

  useEffect( () => {

    const timer = setTimeout( () => {
      setOfferPopup(true)
    }, 15000)

    return () => clearInterval(timer)

  },[])
  
  

  const headerData = {
    heading: "Stress-Free Pet Grooming at Your Ghaziabad Home",
    text: "Same Day Booking - Smart Choice for Ghaziabad Pet Parents.",
  };

  const faqData = {
    heading: "",
    data: [
      {
        question: " How do I book same-day grooming?",
        text: [
          "→ Call/WhatsApp by 10AM for afternoon slots. Fastest response time: 8-10AM.",
        ],
        points: [],
      },
      {
        question: "Do you handle aggressive pets?",
        text: [
          "→ Yes! Our certified groomers use anxiety wraps and positive reinforcement - no muzzles unless requested.",
        ],
        points: [],
      },
      {
        question: "Why choose home service over salon?",
        text: [
          "→ 73% less stress for pets | No exposure to other animals | Your bathroom = their safe space",
        ],
        points: [],
      },
      {
        question: "How long does grooming take?",
        text: [
          "→ Dogs: 60-90 mins | Cats: 45-75 mins (Depends on coat condition)",
        ],
        points: [],
      },
      {
        question: "What areas do you cover?",
        text: [
          "→ All Ghaziabad sectors including Kaushambi, Vaishali, Indirapuram",
        ],
        points: [],
      },
      {
        question: "Can I watch the grooming session?",
        text: ["→ Absolutely! We recommend staying visible for anxious pets."],
        points: [],
      },
      {
        question: "Are your products safe for puppies?",
        text: [
          "→ Only hypoallergenic, paraben-free shampoos specifically formulated for young pets.",
        ],
        points: [],
      },
      {
        question: "What if my pet gets stressed mid-session?",
        text: [
          "→ We immediately pause for cuddle breaks | Use calming sprays | Never force procedures.",
        ],
        points: [],
      },
      // {
      //   question: "",
      //   text: [""],
      //   points: [],
      // },
    ],
  };

  const locationData = {
    data: [
      "Sector 1 to Sector 5 (Vasundhara)",
      "Sector 1 to Sector 16 (Indirapuram)",
      "Sector 1 to Sector 10 (Raj Nagar Ext.)",
      "Sector 1 to Sector 6 (Siddharth Vihar)",
      "Sector 1 to Sector 12 (Govindpuram)",
      "Kaushambi",
      "Vasundhara",
      "Indirapuram",
      "Vaishali",
      "Raj Nagar Extension",
      "Crossing Republik",
      "Mohan Nagar",
      "Sahibabad",
      "Shalimar Garden",
      "Patel Nagar",
      "Kavi Nagar",
      "Sanjay Nagar",
      "Govindpuram",
      "Vijay Nagar",
      "Pratap Vihar",
      "Brij Vihar",
      "Loni",
      "Morta",
      "Muradnagar",
      "Modinagar",
      "Delhi-Meerut RRTS Belt",
      "NH-24 Corridor",
      "Eastern Peripheral Expressway",
      "Hindon Elevated Road Zone",
    ],
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: "Pet Grooming at Home",
    provider: {
      "@type": "LocalBusiness",
      name: "FluffyTouch",
      image: "https://fluffytouch.in/logo.png",
      url: "https://fluffytouch.in/pet-grooming-at-home/ghaziabad",
      telephone: "+91-9658189189",
      priceRange: "₹699 - ₹1499",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Ghaziabad",
        addressRegion: "UP",
        addressCountry: "IN",
      },
      areaServed: [
        "Sector 1 to Sector 5 (Vasundhara)",
        "Sector 1 to Sector 16 (Indirapuram)",
        "Sector 1 to Sector 10 (Raj Nagar Ext.)",
        "Sector 1 to Sector 6 (Siddharth Vihar)",
        "Sector 1 to Sector 12 (Govindpuram)",
        "Kaushambi",
        "Vasundhara",
        "Indirapuram",
        "Vaishali",
        "Raj Nagar Extension",
        "Crossing Republik",
        "Mohan Nagar",
        "Sahibabad",
        "Shalimar Garden",
        "Patel Nagar",
        "Kavi Nagar",
        "Sanjay Nagar",
        "Govindpuram",
        "Vijay Nagar",
        "Pratap Vihar",
        "Brij Vihar",
        "Loni",
        "Morta",
        "Muradnagar",
        "Modinagar",
        "Delhi-Meerut RRTS Belt",
        "NH-24 Corridor",
        "Eastern Peripheral Expressway",
        "Hindon Elevated Road Zone",
      ],
      openingHours: "Mo-Su 06:30-22:00",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Ghaziabad Pet Grooming Packages",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Dog Grooming - Basic Care",
            description: "Medicated bath, nail trim, ear cleaning",
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: "899",
            },
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Dog Grooming - Premium Spa",
            description: "De-shedding, teeth brushing, paw massage",
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: "1499",
            },
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Cat Grooming",
            description: "Stress-free brushing, lion cut, sanitary trims",
            offers: [
              {
                "@type": "Offer",
                priceCurrency: "INR",
                price: "699",
              },
              {
                "@type": "Offer",
                priceCurrency: "INR",
                price: "1299",
              },
              {
                "@type": "Offer",
                priceCurrency: "INR",
                price: "499",
              },
            ],
          },
        },
      ],
    },
    availableChannel: {
      "@type": "ServiceChannel",
      serviceLocation: {
        "@type": "Place",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Ghaziabad",
          addressRegion: "UP",
          addressCountry: "IN",
        },
      },
    },
    validFrom: "2024-01-01",
    validThrough: "2025-09-08",
  };

  return (
    <div>
      <div className="ghaziabad-page">
        <Helmet>
          <title>
            🐾 Pet Grooming at Home in Ghaziabad | Dog & Cat Spa | FluffyTouch
          </title>
          <meta
            name="description"
            content="Expert mobile pet grooming in Ghaziabad! Serving Indirapuram, Vaishali & Crossings Republik. Same-day slots, breed-specific care. 30% OFF 1st booking! Book Now."
          />
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>

        {openForm ? <GroomingFormComponent setDynamicForm={setOpenForm} /> : ""}
        {offerPopup ? <PopupOffer open={setOfferPopup} /> : ""}

        <ScrollNavbar />

        <NavTop />
        <Nav />

        <LocationHeader
          heading={headerData.heading}
          text={headerData.text}
          form={setOpenForm}
          setPetGroom={setPetGroom}
        />

        <NumberIncrement />

        <ExploreGroomingService />

                <LocationGroomingPackageComponent petGroom={petGroom} setPetGroom={setPetGroom} />


        <LocationComponent location="Ghaziabad" data={locationData.data} />
        <MeetExpertsComponent form={setOfferPopup} />

        <HowFt />

        <LocationContentGhaziabad />

        <OurLocation />

        <LocationFaqComponent data={faqData.data} />

        <Footer />
      </div>
    </div>
  );
};

export default GhaziabadPage;
